export default {
  DONOR_CARD_ACTION_MOVE_SUBMIT: 'Move',
  DONOR_CARD_ACTION_ASSIGN: 'Update Assigned',
  DONOR_CARD_ACTION_ASSIGN_SEARCH: 'Search Team Members',
  DONOR_CARD_ACTION_REMOVE_CARD: 'Remove Card',
};
